import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { TEAM, APPROACH, HIGHLIGHTS } from "../data/site";
import { CheckCircle2 } from "lucide-react";
import { Reveal } from "../components/Reveal";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="bg-brand-darkBlue py-16 md:py-20 px-5 md:px-10">
        <div className="max-w-7xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-brand-red mb-3">About Us</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight">Empowering Care, Elevating Lives</h1>
          <p className="mt-5 text-lg text-white/80 max-w-2xl">
            The foundation that created our Health Care Staffing Agency.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-20 md:py-28 px-5 md:px-10">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-brand-darkBlue">Our Multidisciplinary Approach</h2>
            <p className="mt-4 text-lg text-gray-800">{APPROACH.intro}</p>
            <div className="mt-6 space-y-4">
              {APPROACH.paragraphs.map((p, i) => (
                <p key={i} className="text-lg text-gray-800 leading-relaxed">{p}</p>
              ))}
            </div>
            <div className="mt-8 space-y-3">
              {HIGHLIGHTS.map((h) => (
                <div key={h} className="flex items-center gap-3">
                  <CheckCircle2 className="w-6 h-6 text-brand-red shrink-0" />
                  <span className="text-lg text-brand-darkBlue font-medium">{h}</span>
                </div>
              ))}
            </div>
          </div>
          <img src={APPROACH.image} alt="Our care team" className="rounded-3xl shadow-xl w-full h-[440px] object-cover" data-testid="about-image" />
        </div>
      </section>

      {/* Team */}
      <section className="bg-brand-lightBlue py-20 md:py-28 px-5 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-brand-red mb-3">Meet Our Team</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-brand-darkBlue">Experts from various fields</h2>
          </div>
          <div className="mt-12 grid sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
            {TEAM.map((m, i) => (
              <Reveal key={m.name} delay={i * 0.1}>
                <div className="bg-white rounded-2xl shadow-md border border-border overflow-hidden" data-testid="team-member">
                  <div className="overflow-hidden">
                    <motion.img
                      src={m.image}
                      alt={m.name}
                      className="w-full h-80 object-cover object-[center_25%]"
                      whileHover={{ scale: 1.06 }}
                      transition={{ duration: 0.6 }}
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-brand-darkBlue">{m.name}</h3>
                    <p className="text-brand-red font-medium mt-1">{m.role}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 px-5 md:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-brand-darkBlue">Join a team that goes Above and Beyond</h2>
          <p className="mt-4 text-lg text-gray-800">Interested in becoming a part of the HHS team?</p>
          <Link to="/contact#apply" data-testid="about-apply-btn" className="mt-8 inline-flex bg-brand-red text-white font-semibold py-4 px-8 rounded-full hover:bg-brand-redDark transition-colors">
            Apply Here
          </Link>
        </div>
      </section>
    </div>
  );
}
